export enum Languages {
  GE = 'de',
  EN = 'en',
}
